import React from 'react';
import './Paginador.css';
import {animateScroll as scroll} from 'react-scroll';

export const Paginador = (props) => {
	/* Destructuring the props object. */
	const {NumPagina, setNumPagina, onChange, MaxPages, TypeSev} = props;

	/**
	 * If the number is greater than 1, subtract 1 from the number and call the onChange function.
	 */
	const antPagina = () => {
		let number = NumPagina;
		/* A function that is called when the user clicks on the left arrow. It checks if the current page
    is greater than 1, if it is, it subtracts 1 from the current page and calls the onChange
    function. */
		if (number > 1) {
			setNumPagina(number - 1);
			onChange(number - 1, TypeSev);
			scroll.scrollToTop();
		}
	};

	/**
	 * If the current page is less than the maximum number of pages, it adds 1 to the current page and
	 * calls the onChange function.
	 */
	const sigPagina = () => {
		let number = NumPagina;
		/* Checking if the current page is less than the maximum number of pages, if it is, it adds 1 to
    the current page and calls the onChange function. */
		if (number < MaxPages) {
			setNumPagina(number + 1);
			onChange(number + 1, TypeSev);
			scroll.scrollToTop();
		}
	};

	return (
		<div className='paginador'>
			<div className='centrador'>
				<div
					className='button-Izq-paginador'
					onClick={antPagina}
				>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='16'
						height='16'
						fill='currentColor'
						className='bi bi-caret-left-fill'
						viewBox='0 0 16 16'
					>
						<path d='m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z' />
					</svg>
				</div>
			</div>
			<div className='centro-paginador'>{NumPagina}</div>
			<div className='centrador'>
				<div
					className='button-Der-paginador'
					onClick={sigPagina}
				>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='16'
						height='16'
						fill='currentColor'
						className='bi bi-caret-right-fill'
						viewBox='0 0 16 16'
					>
						<path d='m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z' />
					</svg>
				</div>
			</div>
		</div>
	);
};
